import React from 'react'
import PropTypes from 'prop-types'
import { isNil } from 'lodash'
import Formatters from '../../../shared/utils/Formatters';

function UnlockLater({unlockDate, redirectTo, url}) {
  function onClick() {
    redirectTo(url);
  }

  function formattedUnlockDate() {
    if (isNil(unlockDate)) return null;

    return Formatters.date(unlockDate);
  }

  function renderActionButton() {
    return (
      <button className="ds-btn --small -warning _displayBlock _margin--auto" data-testid='unlock-credit-button' 
        data-path={url} onClick={onClick}>
        Unlock credit
      </button>
    );
  }

  return(
    <section className="cardSection _textAlign_center -warning _borderRadiusTop" data-testid="unlock-later-util-card">
      <h2 className="headline -darkBlue _marginBottom--xxsmall" data-testid='unlock-later-title'>
        Your credit is locked until
      </h2>
      <h2 className='headline -primary' data-testid='expected-unlock-date'>
        {formattedUnlockDate()}*
      </h2>
      <p className="byline -secondary --small">*This date is based on all of your upcoming payments being paid on time.</p>
      { redirectTo && url && renderActionButton() }
    </section>
  )
}

UnlockLater.propTypes = {
  unlockDate: PropTypes.instanceOf(Date).isRequired,
  redirectTo: PropTypes.func,
  url: PropTypes.string,
}

export default UnlockLater;



// WEBPACK FOOTER //
// ./src/features/CreditLimit/components/utilization/UnlockLater.js